import { Card, Flex, Tag } from 'antd';
import { useTranslation } from 'translations/hooks';

import { Ring } from 'technical/db';
import { formatDateWithMiddleDot } from 'technical/format/date';
import { formatUserName } from 'technical/string/formatter';

import styles from './index.module.scss';

export const RingBody = ({ ring }: { ring: Ring }) => {
  const { t } = useTranslation();

  return (
    <Card
      title={t(
        'qualityControl.recordSegmentDefect.rightPanel.ringDetails.detailCard.title',
      )}
      className={
        ring.compliantDate ? styles.compliantCard : styles.nonCompliantCard
      }
      size="small"
      variant="borderless"
      classNames={{ header: styles.complianceCardHeader }}
    >
      <Card size="small" variant="borderless">
        <Flex justify="space-between">
          {ring.compliantDate ? (
            <>
              {t(
                'qualityControl.recordSegmentDefect.rightPanel.ringDetails.detailCard.ringCompliance',
              )}
              <Tag className={styles.complianceTag}>
                <span>&#x25CF; </span>
                {t(
                  'qualityControl.recordSegmentDefect.rightPanel.ringDetails.detailCard.complianceState',
                )}
              </Tag>
            </>
          ) : (
            t(
              'qualityControl.recordSegmentDefect.rightPanel.ringDetails.detailCard.waitingCompliance',
            )
          )}
        </Flex>

        <span className={styles.complianceDetails}>
          {ring.compliantDate && ring.userFirstName && ring.userLastName
            ? `${formatDateWithMiddleDot(ring.compliantDate)} \u2022 ${formatUserName({ firstName: ring.userFirstName, lastName: ring.userLastName })}`
            : null}
        </span>
      </Card>
    </Card>
  );
};
